import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import "react-toastify/dist/ReactToastify.css";
import "./ProfileSettingStyle.scss";
import updateIconImg from "../../Assets/updateIconImg.png";
import deleteIcon from "../../Assets/deleteIcon.png";
import { toast } from "react-toastify";
import { errorToastStyle } from "../../Shared/Utils/ToastUtils";
import DeleteDialog from "./DeleteDialog";
import { useDispatch, useSelector } from "react-redux";
import * as profileSelector from "../../Store/Profile/ProfileSelector";
import {
  fetchProfileData,
  onChaneProfileDetails,
  updateProfileDetails,
  // updateProfilePhoto,
} from "../../Store/Profile/ProfileAction";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../ChangeLanguage/LanguageProvider";
import UserRoles from "../../Shared/Constant/UserRoles";
const ProfileSetting = () => {
  const { t } = useTranslation("profile");
  const { selectedLanguageId } = useLanguage();
  const [editProfile, setEditProfile] = useState(false);
  const profileData = useSelector(profileSelector.getProfileInfo);
  const emailfromselector = useSelector(profileSelector.getProfileInfo).email;
  const [deleteFlag, setDeleteFlag] = useState(false);
  const profilePhoto = useSelector(profileSelector.getProfilePhoto);
  const emailid = profileData.email || ""; // handle undefined email
  const contactno = profileData.mobileno || "";
  const [email, setEmail] = useState(emailid);
  const [emailError, setEmailError] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const contactError = false;
  const [popUpVisible, setPopUpVisible] = useState(false);
  const [fileInputDisabled, setFileInputDisabled] = useState(false);
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  const emailRegex = /^[a-z0-9._%+-]+@[a-z.-]+\.com$/;

  const emailChange = (e) => {
    dispatch(onChaneProfileDetails({ email: e.target.value }));
    setEmail(e.target.value);
  };
  const editProfileHandle = () => {
    setEditProfile(true);
  };
  const handleDeletePhoto = () => {
    setFileInputDisabled(false);
    setDeleteFlag(true);
  };
  const handleSaveChanges = ({ email, contact }) => {
    setNewEmail(email);
    dispatch(
      updateProfileDetails(
        { email },
        emailfromselector,
        fileInputDisabled,
        file,
        deleteFlag,
        selectedLanguageId
      )
    );
    setDeleteFlag(false);
    setEditProfile(false);
    if (newEmail !== "") {
      dispatch(fetchProfileData(selectedLanguageId));
    }
  };
  useEffect(() => {
    dispatch(fetchProfileData(selectedLanguageId));
  }, [dispatch, selectedLanguageId, editProfile, newEmail]);

  const handleCancel = () => {
    setPopUpVisible(false);
  };
  const emailRegexCheck = (e) => {
    if (!emailRegex.test(e.target.value)) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }
  };
  const role = sessionStorage.getItem("userRole");

  const handleFileUpload = (event) => {
    if (profileData.profilePhoto != null) {
      setFileInputDisabled(true);
      toast.error("Delete the existing profile photo and Retry", {
        style: errorToastStyle,
        autoClose: 5000,
      });
    } else {
      setFileInputDisabled(false);
      event.target.disabled = false;
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        setFile(selectedFile); // Update file state when a new file is selected
      }
    }
  };
  useEffect(() => {
  }, [profilePhoto, file, editProfile, newEmail]);

  useEffect(() => {
    if (deleteFlag) {
      setFile(null); // Update file state when deleteFlag is true
    }
  }, [deleteFlag]);

  // Function to handle edit profile click
  const firstInitial = profileData.firstname
    ? profileData.firstname.charAt(0).toUpperCase()
    : "";
  let label = firstInitial;
  function getImageUrl(file, profileData) {
    if (file) {
      return URL.createObjectURL(file);
    } else if (profileData.profilePhoto) {
      return typeof profileData.profilePhoto === "string"
        ? profileData.profilePhoto
        : URL.createObjectURL(profileData.profilePhoto);
    } else {
      return "";
    }
  }
  const imageUrl = getImageUrl(file, profileData);
  let avatarOrImage;

  if (file || profileData.profilePhoto) {
    avatarOrImage = (
      <img
        src={imageUrl}
        alt="Selected"
        className="avatar-image"
        style={{
          height: "6rem",
          width: "5rem",
          borderRadius: "1rem",
        }}
      />
    );
  } else {
    avatarOrImage = (
      <Avatar
        label={label}
        size="xlarge"
        style={{
          backgroundColor: "rgb(222, 226, 230)",
          color: "black",
        }}
      />
    );
  }

  const headercomponent = () => {
    return (
      <div className="flex">
        <img src={deleteIcon} alt="delete-icon" className="popupdlticon" />
        <div className="text-xl font-light ml-2" style={{ color: "#E9573E" }}>
          Delete Profile Photo
        </div>
      </div>
    );
  };
  const styleEdit = editProfile ? "#ECECEC" : "inherit";
  return (
    <>
      <div
        className="mt-4 p-6 border-round-xl"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        {editProfile ? null : (
          <div className="flex justify-content-end">
            <Button
              label={t("Edit Profile")}
              className="btnstyle"
              onClick={editProfileHandle}
              data-testid="edit-profile-button" //added for test files
            />
          </div>
        )}
        <div className="mb-5 mr-14">
          <div className="flex justify-content-center gap-3">
            <div className="flex">
              {editProfile && (
                <div>
                  <div data-testid="change-photo-button">
                    <label htmlFor="imageUpload" className="flex">
                      <div className="text-xs font-normal">
                        {t("Change Photo")}
                      </div>
                      <img
                        src={updateIconImg}
                        alt="edit-icon"
                        className="iconimagestyle"
                      />
                    </label>
                    <input
                      id="imageUpload"
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleFileUpload}
                      disabled={fileInputDisabled}
                    />
                  </div>
                  <div className="flex" onClick={handleDeletePhoto}>
                    <div className="text-xs font-normal mr-1">
                      {t("Delete Photo")}
                    </div>
                    <img
                      src={deleteIcon}
                      alt="delete-icon"
                      className="iconimagestyle"
                    />
                  </div>
                </div>
              )}
              {deleteFlag ? (
                <Avatar
                  label={label}
                  size="xlarge"
                  style={{
                    backgroundColor: "rgb(222, 226, 230)",
                    color: "black",
                  }}
                />
              ) : (
                avatarOrImage
              )}
            </div>
            <div>
              <div className="font-normal text-xl bluetext">
                {profileData.firstname} {profileData.lastname}
              </div>
              <div
                className="mt-1 text-xl font-light graytext"
                data-testid="role"
              >
                {role}
              </div>
            </div>
          </div>
        </div>
        <div className="mb-4">
          <div className="grid flex gap-6 justify-content-center mb-2">
            <div className="p-col-12 p-md-6">
              <div
                style={{
                  fontSize: "16px",
                  marginBottom: "9px",
                  fontWeight: "600",
                }}
              >
                {t("FirstName")}:
              </div>
              <div>
                <InputText
                  id="fname"
                  value={profileData.firstname}
                  disabled
                  className="textboxstyle"
                  style={{
                    backgroundColor: styleEdit,
                  }}
                  data-testid="fname-input"
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div
                style={{
                  fontSize: "16px",
                  marginBottom: "9px",
                  fontWeight: "600",
                }}
              >
                {t("LastName")}:
              </div>
              <div>
                <InputText
                  id="lname"
                  value={profileData.lastname}
                  disabled
                  className="textboxstyle"
                  style={{
                    backgroundColor: styleEdit,
                  }}
                  data-testid="lname-input"
                />
              </div>
            </div>
          </div>
          {/* Rest of the grid sections */}
          <div className="grid flex gap-6 justify-content-center mb-2 mt-4">
            <div className="p-col-12 p-md-6">
              <div
                style={{
                  fontSize: "16px",
                  marginBottom: "9px",
                  fontWeight: "600",
                }}
              >
                {t("Role")}:
              </div>
              <div>
                <InputText
                  id="role"
                  value={role}
                  className="textboxstyle"
                  style={{
                    backgroundColor: styleEdit,
                  }}
                  disabled
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div
                style={{
                  fontSize: "16px",
                  marginBottom: "9px",
                  fontWeight: "600",
                }}
              >
                {t("Designation")}:
              </div>
              <div>
                <InputText
                  id="designation"
                  value={profileData.designation}
                  disabled
                  style={{
                    backgroundColor: styleEdit,
                  }}
                  className="textboxstyle"
                />
              </div>
            </div>
          </div>
          <div className="grid flex gap-6 justify-content-center mb-2 mt-4">
            <div className="p-col-12 p-md-6">
              <div
                style={{
                  fontSize: "16px",
                  marginBottom: "9px",
                  fontWeight: "600",
                }}
              >
                {t("Email")}:
              </div>
              <div>
                <InputText
                  id="email"
                  value={emailid}
                  onChange={(e) => {
                    emailChange(e);
                    emailRegexCheck(e);
                  }}
                  disabled={!editProfile}
                  className="textboxstyle"
                  data-testid="email-input"
                />
              </div>
              {emailError && (
                <div className="text-red-500">Please enter a valid email</div>
              )}
            </div>
            <div className="p-col-12 p-md-6">
              <div
                style={{
                  fontSize: "16px",
                  marginBottom: "9px",
                  fontWeight: "600",
                }}
              >
                {t("ContactNumber")}:
              </div>
              <div>
                <InputText
                  id="contact"
                  value={contactno}
                  disabled
                  style={{
                    backgroundColor: styleEdit,
                  }}
                  className="textboxstyle"
                  data-testid="contact-input"
                />
              </div>
              {contactError && (
                <div className="text-red-500">
                  Enter a Correct Mobile Number
                </div>
              )}
            </div>
          </div>
          <div className="grid flex gap-6 justify-content-center mb-2 mt-4">
            <div className="p-col-12 p-md-6">
              <div
                style={{
                  fontSize: "16px",
                  marginBottom: "9px",
                  fontWeight: "600",
                }}
              >
                {t("LoginId")}:
              </div>
              <div>
                <InputText
                  id="loginid"
                  value={profileData.loginid}
                  disabled
                  className="textboxstyle"
                  style={{
                    backgroundColor: styleEdit,
                  }}
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div
                style={{
                  fontSize: "16px",
                  marginBottom: "9px",
                  fontWeight: "600",
                }}
              >
                {t("State")}:
              </div>
              <div>
                <InputText
                  id="stateName"
                  value={profileData.state}
                  className="textboxstyle"
                  style={{
                    backgroundColor: styleEdit,
                  }}
                  disabled
                />
              </div>
            </div>
          </div>
          <div className="grid flex gap-6 justify-content-center mb-2 mt-4">
            {role === UserRoles.PHCHEAD ||
              role === UserRoles.DISTRICTHEAD ||
              (role === UserRoles.BLOCKHEAD && (
                <div className="p-col-12 p-md-6">
                  <div
                    style={{
                      fontSize: "16px",
                      marginBottom: "9px",
                      fontWeight: "600",
                    }}
                  >
                    {t("District")}:
                  </div>
                  <div>
                    <InputText
                      id="districtName"
                      value={profileData.district}
                      className="textboxstyle"
                      style={{
                        backgroundColor: styleEdit,
                      }}
                      disabled
                    />
                  </div>
                </div>
              ))}
            {role === UserRoles.PHCHEAD ||
              (role === UserRoles.BLOCKHEAD && (
                <div className="p-col-12 p-md-6">
                  <div
                    style={{
                      fontSize: "16px",
                      marginBottom: "9px",
                      fontWeight: "600",
                    }}
                  >
                    {t("Taluka")}:
                  </div>
                  <div>
                    <InputText
                      id="talukaName"
                      value={profileData.taluka}
                      className="textboxstyle"
                      style={{
                        backgroundColor: styleEdit,
                      }}
                      disabled
                    />
                  </div>
                </div>
              ))}
          </div>
          <div className="grid flex gap-6 justify-content-center mb-2 mt-4">
            {role === UserRoles.PHCHEAD && (
              <div className="p-col-12 p-md-6" style={{ marginLeft: "3rem" }}>
                <div
                  style={{
                    fontSize: "16px",
                    marginBottom: "9px",
                    fontWeight: "600",
                  }}
                >
                  {t("PHC")}:
                </div>
                <div>
                  <InputText
                    id="phcName"
                    value={profileData.phc}
                    className="textboxstyle"
                    style={{
                      backgroundColor: styleEdit,
                    }}
                    disabled
                  />
                </div>
              </div>
            )}
            <div className="p-col-12 p-md-6">
              <div
                style={{
                  fontSize: "16px",
                  marginBottom: "9px",
                  fontWeight: "600",
                }}
              ></div>
              <div></div>
            </div>
          </div>
        </div>
        {editProfile && (
          <div className="flex justify-content-end gap-3">
            <Button
              label={t("Cancel")}
              tooltip="CANCEL"
              placeholder="Top"
              tooltipOptions={{
                showDelay: 100,
                hideDelay: 100,
                position: "top",
                mouseTrack: true,
              }}
              className="cancelbtnstyle"
              onClick={() => setEditProfile(false)}
            />
            <Button
              label={t("Save Changes")}
              className="btnstyle"
              onClick={() => handleSaveChanges({ email })}
              disabled={emailError || contactError}
              data-testid="save-changes-button"
            />
          </div>
        )}
        {popUpVisible && (
          <DeleteDialog
            popUpVisible={popUpVisible}
            setPopUpVisible={setPopUpVisible}
            handleCancel={handleCancel}
            headercomponent={headercomponent}
          />
        )}
      </div>
    </>
  );
};

export default ProfileSetting;
